import React from "react";

class ResetHandler extends React.Component {
  componentDidMount() {
    const { triggerNextStep } = this.props;

    // No intentamos modificar steps (son inmutables)
    // Simplemente redirigimos al menú principal
    triggerNextStep({ trigger: "mainmenu" });
  }

  render() {
    return null;
  }
}

export default ResetHandler;
